<h1 mat-dialog-title> </h1>
<div mat-dialog-content>
    <mat-card class="example-card">
        <mat-card-header>
            <mat-card-title>{{ 'WIZARD.DOCUMENTADOR.LABEL05' | translate}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <!-- {{this.langs}} -->
            <!-- C:\CGO\surveyadministrator\frontend\src\assets\video\norma35 -->
            <video autoplay id="videoLanding" [@animate]="{value:'*',params:{y:'100%'}}" style="width: 520px; height: 380px;" src="./assets/video/norma35/Disposicion6.1.mov" controls fxFlex="100" fxLayoutAlign="center center" poster="">
            </video>
        </mat-card-content>
    </mat-card>
</div>
<div mat-dialog-actions>
</div>